import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { PAYMENT_FORM_WIDTH } from "./payment/constants";

const ZeroAmountMessage = () => {
  return (
    <Box
      sx={{
        minWidth: 400,
        maxWidth: PAYMENT_FORM_WIDTH,
        margin: "auto",
        padding: 3,
      }}
    >
      <Alert
        severity="warning"
        icon={<InfoOutlinedIcon fontSize="inherit" />}
        sx={{
          borderRadius: 2,
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          Invalid Amount: Transaction cannot be processed with a value of $0.00.
        </Typography>
      </Alert>
    </Box>
  );
};

export default ZeroAmountMessage;
